import { useId } from 'react';
import { Combobox } from '../Combobox';
import type { ComboboxContentProps } from '../Combobox/types';
import { Label } from '../Label';
import { cn } from '../../lib/utils';
import useI18n from '../../hooks/useI18n';

export type PageSizeSelectProps = {
  value: number;
  options?: number[];
  onValueChange: (value: number) => void;
  className?: string;
  container?: ComboboxContentProps['container'];
};

export function PageSizeSelect({
  value,
  options = [10, 20, 50],
  onValueChange,
  className,
  container,
}: PageSizeSelectProps) {
  const { t } = useI18n();
  const id = useId();

  return (
    <div
      className={cn(
        'eye:body-s eye:flex eye:items-center eye:gap-8',
        className,
      )}
    >
      <Label className='eye:body-s eye:whitespace-nowrap' htmlFor={id}>
        {t('rowsPerPage')}
      </Label>
      <div className='eye:w-[93px]'>
        <Combobox<number>
          id={id}
          items={options}
          value={value}
          onValueChange={(next) => {
            if (next != null) onValueChange(next);
          }}
          filter={null}
          slotProps={{
            searchInput: { className: 'eye:hidden' },
            trigger: { 'aria-label': t('rowsPerPage') },
            content: { container },
          }}
        />
      </div>
    </div>
  );
}
